// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import NewIcon from 'components/common/Icons/NewIcon/NewIcon';
import './UserMenuItem.scss';

type Props = {
  to?: ?string,
  href?: ?string,
  target?: ?string,
  children: any,
  isNew: boolean,
};

const UserMenuItem = ({ to, href, target, isNew, children, ...rest }: Props) => {
  if (href) {
    return (
      <a className="user-menu-item" href={href} target={target} rel="noopener noreferrer" {...rest}>
        <span>
          {children}
          {isNew && <NewIcon />}
        </span>
      </a>
    );
  }

  if (!to) {
    return (
      <span className="user-menu-item" {...rest}>
        {children}
      </span>
    );
  }

  return (
    <Link className="user-menu-item" to={to} {...rest}>
      <span>
        {children}
        {isNew && <NewIcon />}
      </span>
    </Link>
  );
};

UserMenuItem.defaultProps = {
  to: null,
};

export default UserMenuItem;



// WEBPACK FOOTER //
// ./src/components/base/UserMenuItem/UserMenuItem.js